import { tss } from 'tss-react/mui';

export const useListPageStyles = tss.create(({ theme }) => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '24px 8px',
  },
  card: {
    boxShadow: 'none',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    padding: theme.spacing(2),
  },
  searchField: {
    width: '100%',
    maxWidth: 300,
    minWidth: 200,
    marginRight: 'auto',
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(1),
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.background.paper,
    },
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
      color: theme.palette.text.secondary,
    },
    '& .MuiOutlinedInput-input::placeholder': {
      color: theme.palette.text.secondary,
      opacity: 1,
    },
  },
  actionMenu: {
    minWidth: 156,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    padding: 8,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.extendedGrey?.lighter}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[8],
  },
  actionMenuButton: {
    justifyContent: 'flex-start',
    gap: 10,
    borderRadius: 6,
    width: '100%',
    textTransform: 'none',
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(6),
    color: theme.palette.text.secondary,
  },
}));

export const useFormDialogStyles = tss.create(({ theme }) => ({
  modalPaper: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '90vh',
    borderRadius: theme.spacing(1.5),
  },
  modalForm: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
  },
  modalContent: {
    padding: theme.spacing(3),
    paddingTop: theme.spacing(2),
  },
  modalActions: {
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
}));
